import { FC } from 'react'
import { EntityTrackView } from '@ryddm-inc/ryddm-apiclient'

// hooks
import { useAppSelector, useAppDispatch } from '@/hooks'
// features
import {
  // track
  TrackTile,
  trackSelectTrackDeleteLoading,
  trackSelectTrackDeleteModalTrack,
  trackDelete,
  // player
  playerAudioSetCurrentTrack,
} from '@/features'
// components
import { Loader, ButtonLarge } from '@/components'

// styles
import { styles } from './styles'

type TrackDeleteFormProps = {}

export const TrackDeleteForm: FC<TrackDeleteFormProps> = () => {
  const dispatch = useAppDispatch()
  const trackDeleteLoading = useAppSelector(trackSelectTrackDeleteLoading)
  const track = useAppSelector(trackSelectTrackDeleteModalTrack)

  const submitDisabled = trackDeleteLoading

  return (
    <div css={styles().form.main}>
      <form
        css={styles().form.content.main}
        onSubmit={(e) => {
          e.preventDefault()
          dispatch(trackDelete({ id: track?.id || '' }))
        }}
      >
        <div css={styles().form.content.track}>
          <TrackTile
            track={track || {}}
            onClick={() =>
              dispatch(
                playerAudioSetCurrentTrack({
                  track: track as EntityTrackView,
                }),
              )
            }
            onAuthorNameClick={() => {}}
          />
        </div>
        <div css={styles().form.content.submit}>
          <ButtonLarge
            type="submit"
            aria-label="delete track"
            disabled={submitDisabled}
            appearance="primary"
          >
            {trackDeleteLoading ? (
              <Loader width={50} height={20} appearance="primary" />
            ) : (
              'Delete'
            )}
          </ButtonLarge>
        </div>
      </form>
    </div>
  )
}

TrackDeleteForm.propTypes = {}
